import { render } from "./PurchaseOrderView.vue?vue&type=template&id=488c07d2&scoped=true"
import script from "./PurchaseOrderView.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderView.vue?vue&type=script&lang=js"

import "./PurchaseOrderView.vue?vue&type=style&index=0&id=488c07d2&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488c07d2"]])

export default __exports__